import { useMemo } from 'react'
import {
  ONBOARDING_CALENDAR_SYNC_SUPPORTED_INTEGRATIONS,
  ONBOARDING_CONTACT_SYNC_SUPPORTED_INTEGRATIONS,
  IntegrationCategory,
  IntegrationServiceId,
  getIntegrationServiceIdsForCategory,
} from '../../../common/integrations'
import { getOnboardingCrmSettingsProvider } from '../../Integration/IntegrationManagement/OnboardingSupport/settingsProviders'

export type PostConnectIntent = 'calendar' | 'contacts' | 'zoom'

export type PostConnectStep =
  | 'calendar-event-filters'
  | 'crm-calendar-sync'
  | 'contact-sync'
  | 'calendar-success'
  | 'contacts-success'
  | 'zoom-settings'
  | 'zoom-success'

export const usePostConnectSteps = (serviceId: IntegrationServiceId, intent: PostConnectIntent | null): PostConnectStep[] => {
  return useMemo(() => {
    if (intent === 'calendar') {
      if (getIntegrationServiceIdsForCategory(IntegrationCategory.CALENDAR).includes(serviceId)) {
        return ['calendar-event-filters', 'calendar-success']
      }
      if (ONBOARDING_CALENDAR_SYNC_SUPPORTED_INTEGRATIONS.includes(serviceId) && getOnboardingCrmSettingsProvider(serviceId)) {
        return ['crm-calendar-sync', 'calendar-event-filters', 'calendar-success']
      }
      return []
    }

    if (intent === 'contacts') {
      if (ONBOARDING_CONTACT_SYNC_SUPPORTED_INTEGRATIONS.includes(serviceId) && getOnboardingCrmSettingsProvider(serviceId)) {
        return ['contact-sync', 'contacts-success']
      }
      return []
    }

    if (intent === 'zoom') {
      if (serviceId === IntegrationServiceId.ZOOM) {
        return ['zoom-settings', 'zoom-success']
      }
      return []
    }

    return []
  }, [serviceId, intent])
}
